export const ttlockConfig = {
  credentials: {
    title: "Configuração do TTLock",
    subtitle: "Insira as credenciais da sua conta TTLock",
    savedBadge: "Credenciais salvas",
    noneBadge: "Sem credenciais",
    emailLabel: "O e-mail da sua conta TTLock",
    emailPlaceholder: "you@example.com",
    emailHelp: "O e-mail que você usa para entrar no TTLock",
    passwordLabel: "Senha",
    passwordPlaceholderSaved: "•••••••• (salva, opcional alterar)",
    passwordPlaceholder: "Sua senha do TTLock",
    passwordHelpSaved: "Você pode deixar em branco se já tiver uma salva.",
    passwordHelp: "A senha da sua conta TTLock.",
    testing: "Testando...",
    testConnection: "Testar conexão",
    saving: "Salvando...",
    saveCredentials: "Salvar credenciais",
  },
  selector: {
    title: "Seletor de fechaduras para esta propriedade",
    subtitleBefore: "Selecione apenas as fechaduras que se aplicam a ",
    subtitleStrong: "esta propriedade",
    subtitleAfter: ".",
    selectedCount: "{count} selecionada | {count} selecionadas",
    hintBefore: "Insira suas credenciais e pressione ",
    hintStrong: "Testar conexão",
    hintAfter: " para carregar suas fechaduras.",
    noneFound: "Nenhuma fechadura encontrada. Verifique sua conta TTLock.",
    placeholder: "Selecione as fechaduras…",
    summaryCount: "{count} fechadura selecionada | {count} fechaduras selecionadas",
    emptySelection: "Nenhuma fechadura selecionada",
    saving: "Salvando...",
    save: "Salvar fechaduras para esta propriedade",
  },
  gateway: {
    with: "Com Gateway",
    without: "Sem Gateway",
  },
  pms: {
    title: "Controle e atribuição (PMS)",
    subtitleP1: "Atribua cada fechadura à ",
    subtitleStrongMain: "Porta principal",
    subtitleP2: " ou ",
    subtitleStrongUnit: "Unidade",
    subtitleP3: ".",
    assignedCount: "{count} atribuída | {count} atribuídas",
    empty: "Você ainda não tem fechaduras salvas para esta propriedade.",
    assignmentLabel: "Atribuição",
    assignmentNone: "Não atribuída",
    assignmentCommon: "Porta principal (compartilhada)",
    assignmentUnit: "Porta do apartamento",
    hintNone: "Não será controlada pelo PMS.",
    hintAssigned: "Será vinculada a esta propriedade para controle/PINs.",
    unitLabel: "Unidade / Acomodação",
    unitSelectPlaceholder: "Selecione uma unidade",
    unitHint: "Selecione qual unidade esta fechadura abre.",
    nameLabel: "Nome (opcional)",
    namePlaceholder: "ex.: Porta principal / Apt 101",
    saving: "Salvando...",
    save: "Salvar atribuição",
  },
  actions: {
    lock: "Trancar",
    unlock: "Destrancar",
    requiresGateway: "Requer Gateway",
    createPasscode: "Criar senha",
    passcodeHistory: "Histórico de senhas",
    refreshStatus: "Atualizar status",
  },
  lockFallbackName: "Fechadura {id}",
  unitFallbackName: "Unidade {id}",
  history: {
    title: "Histórico de senhas",
    revocationTitle: "Sobre a revogação de senhas:",
    withGatewayLabel: "Com gateway:",
    withGatewayText: "A senha é revogada imediatamente na fechadura física.",
    withoutGatewayLabel: "Sem gateway:",
    withoutGatewayText:
      "A senha é removida do servidor TTLock, mas continuará funcionando na fechadura até que alguém se conecte via Bluetooth pelo aplicativo e sincronize.",
    loading: "Carregando histórico…",
    empty: "Nenhuma senha registrada para esta fechadura.",
    colAlias: "Apelido",
    colPasscode: "Senha",
    colValidity: "Validade",
    colStatus: "Status",
    createdAt: "Criada: {date}",
    fromLabel: "De:",
    toLabel: "Até:",
    revokedTitle: "Já revogada",
    revokeTitle: "Excluir / Revogar senha",
    close: "Fechar",
  },
  passcodeModal: {
    title: "Criar senha temporária",
    nameLabel: "Nome / Rótulo",
    namePlaceholder: "ex.: Limpeza / Hóspede / Técnico",
    nameHint: "Este nome ajudará você a identificar a senha.",
    validFrom: "Válida a partir de",
    validTo: "Válida até",
    importantLabel: "Importante:",
    importantText:
      "A senha será gerada automaticamente pelo TTLock e ficará disponível apenas durante o período especificado. O hóspede pode digitar essa senha diretamente no teclado da fechadura (funciona sem internet).",
    noGatewayLabel: "Sem Gateway:",
    noGatewayText:
      "Esta fechadura não tem gateway conectado. As senhas geradas funcionarão perfeitamente no teclado físico, mas você não poderá revogá-las remotamente por este painel. Para revogar, será necessário fazer isso pelo aplicativo TTLock conectando via Bluetooth.",
    cancel: "Cancelar",
    creating: "Criando...",
    create: "Criar senha",
  },
  states: {
    active: "Ativa",
    upcoming: "Futura",
    expired: "Expirada",
    revoked: "Revogada",
    noDate: "Sem data",
  },
  confirm: {
    revoke:
      'Tem certeza de que deseja revogar/excluir a senha "{alias}"?\n\nObservação: Se a fechadura não tiver gateway, a revogação pode ser apenas parcial.',
  },
  toast: {
    noLocksFound: "Nenhuma fechadura encontrada no TTLock.",
    loadStatusError: "Não foi possível carregar o status da fechadura",
    loadStatusErrorGeneric: "Erro ao carregar o status da fechadura",
    credentialsRequired: "Você deve inserir um nome de usuário e senha, ou ter credenciais salvas.",
    connectionOk:
      "Conexão bem-sucedida. {count} dispositivo encontrado. | Conexão bem-sucedida. {count} dispositivos encontrados.",
    testError: "Erro ao testar a conexão",
    credentialsSaved: "Credenciais salvas com sucesso",
    saveCredentialsError: "Erro ao salvar as credenciais",
    saveCredentialsErrorDetail: "Erro ao salvar as credenciais: {msg}",
    selectAtLeastOne: "Você deve selecionar pelo menos um dispositivo para esta propriedade.",
    devicesSaved: "Dispositivos salvos para esta propriedade",
    devicesSaveError: "Não foi possível salvar os dispositivos",
    saveErrorDetail: "Erro ao salvar: {msg}",
    unitRequired: "Selecione a unidade para as fechaduras atribuídas como 'Porta do apartamento'.",
    bindingsSaved: "Atribuição salva com sucesso",
    bindingsSaveError: "Não foi possível salvar a atribuição",
    bindingsSaveErrorDetail: "Erro ao salvar a atribuição: {msg}",
    assignFirst: "Primeiro atribua a fechadura (porta principal ou unidade) e salve para ativar o controle.",
    passcodeNameRequired: "Você deve fornecer um nome/rótulo para a senha.",
    passcodeDatesRequired: "Você deve fornecer uma data de início e de término de validade.",
    passcodeCreated: "Senha criada: {code}",
    passcodeCreateError: "Não foi possível criar a senha",
    passcodeCreateErrorGeneric: "Erro ao criar a senha",
    lockLocked: "Fechadura trancada",
    lockLockError: "Não foi possível trancar",
    lockLockErrorGeneric: "Erro ao trancar",
    lockUnlocked: "Fechadura destrancada",
    lockUnlockError: "Não foi possível destrancar",
    lockUnlockErrorGeneric: "Erro ao destrancar",
    revokeNoProviderId: "Esta senha não tem provider_passcode_id. Não pode ser revogada no TTLock.",
    revokedOk: "Senha totalmente revogada",
    revokeError: "Não foi possível revogar",
    revokeErrorGeneric: "Erro ao revogar a senha",
    historyLoadError: "Não foi possível carregar o histórico",
    historyLoadErrorGeneric: "Erro ao carregar o histórico",
  },
};
